import { Injectable } from '@angular/core';
import {Response, RequestOptionsArgs, Headers, Http, Connection, RequestOptions} from '@angular/http';

import { API_ENDPOINTS } from '../../shared/configuration/api-endpoints';

import { StorageService } from '../../shared/services/storage.service';
import { ErrorService } from '../../shared/services/error.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';

@Injectable()
export class ResetPasswordService{

    vResetPasswordData: {
        email: string,
        security_question: string,
        security_answer: string
    }

    vSetPasswordData: {
        email: string,
        confirmation_code: string,
        password: string,
        retype_password: string
    }

    vLoadingSecurity: boolean;
    vLoadingStatus: boolean;

    constructor(
        private _http: Http,
        private _errorService: ErrorService,
        private _storageService: StorageService,
        private _pageNavigationService: PageNavigationService,
    ) {
        this.vLoadingSecurity = false;
        this.vLoadingStatus = false;
    }

    getResetPasswordData(){
        return this.vResetPasswordData;
    }

    getNewPasswordData(){
        return this.vSetPasswordData;
    }

    isLoadingSecurity(){
        return this.vLoadingSecurity;
    }

    isLoading(){
        return this.vLoadingStatus;
    }

    resetResetPasswordData(){
        this.vResetPasswordData = {
            email: '',
            security_question: '',
            security_answer: ''
        };
    }

    resetNewPasswordData(){
        this.vSetPasswordData = {
            email: "",
            confirmation_code : "",
            password: "",
            retype_password: ""
        };
    }

    resetError() {
        this._errorService.resetErrorFlag();
        this._errorService.resetError();
        this._errorService.resetBackEndError();
    }

    isDisableInputResetPassword(){
        return (this.vResetPasswordData.email === undefined || this.vResetPasswordData.email === ''
            || this.vResetPasswordData.security_answer === undefined || this.vResetPasswordData.security_answer === '' 
            || this.vResetPasswordData.security_question === undefined || this.vResetPasswordData.security_question === '') ? true: false;
    }

    isDisableInputNewPassword(){
        return (this.vSetPasswordData.confirmation_code === undefined || this.vSetPasswordData.confirmation_code === ''
            || this.vSetPasswordData.password === undefined || this.vSetPasswordData.password === '' 
            || this.vSetPasswordData.retype_password === undefined || this.vSetPasswordData.retype_password === ''
            || this.vSetPasswordData.password.length < 8) ? true: false;
    }

    loadSecurityQuestion(){
        this.resetError();
        this.vResetPasswordData.security_question = '';

        if(this.vResetPasswordData.email === undefined || this.vResetPasswordData.email === ''){
            return;
        } else if(!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.vResetPasswordData.email)){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('email', 'Email Address provided is not valid');
            return;
        }
        
        this.vLoadingSecurity = true;
        this._http.get(API_ENDPOINTS.ACCOUNT.GET_SECURITY_QUESTION + '?email=' + this.vResetPasswordData.email).subscribe(
            (response) => {
                this.vLoadingSecurity = false;
                let vResponseData:any = response;
                console.log(vResponseData);
                this.vResetPasswordData.security_question = vResponseData.data.security_question;
            },

            (error) => {
                this.vLoadingSecurity = false;
                let vErrorData = error;
                console.log(vErrorData);
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }

    resetPassword() {
        this.resetError();

        this.vLoadingStatus = true;
        this._http.post(API_ENDPOINTS.ACCOUNT.VALIDATE_SECURITY_QUESTION, this.vResetPasswordData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                console.log(response);
                this.sendCode().then(
                    (resolve) => {
                        this._storageService.setSessionItem('temporaryEmail', this.vResetPasswordData.email);
                        this._pageNavigationService.navigate(['set-new-password']);
                    },
                    (reject) => {

                    }
                );
            },

            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }

    sendCode(){
        var xData = {
            email: this.vResetPasswordData.email
        }
        this.vLoadingStatus = true;
        var promise = this._http.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, xData);
        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            response => {
                this.vLoadingStatus = false;
                resolve();
            },
            error  => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    changePassword() {
        this.resetError();

        if(this.vSetPasswordData.retype_password !== this.vSetPasswordData.password){
            this._errorService.setErrorFlag(true);
            //this._errorService.setErrorStatusAndMessage('retypePassword', 'The password are not match');
            this._errorService.setErrorStatusAndMessage('retypePassword', 'The new password and confirm new password does not match.');//Changed by Anjaiah

            return;
        }

        this.vSetPasswordData.email = this._storageService.getSessionItem('temporaryEmail');
        this.vLoadingStatus = true;
        
        this._http.post(API_ENDPOINTS.AUTH.CONFIRM_FORGOT_PASSWORD, this.vSetPasswordData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                console.log(response);
                this._storageService.removeSessionItem('temporaryEmail');
                this._pageNavigationService.navigate(['reset-password-confirmation']);
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/login/services/reset-password.service.ts